<template>
    <div>
        <div class="writing_nav">
            <div class="writing_nav_con">
                <router-link to="/toPromote/myPromotion" active-class="active" class="writing_nav_list" :class="{'active': $route.meta.requiresAuth}"><span><img src="@a/img/sv75.svg"/><img src="@a/img/sv75on.svg"/></span>我要推广</router-link>
                <router-link to="/toPromote/myClient" active-class="active" class="writing_nav_list"><span><img src="@a/img/sv76.svg"/><img src="@a/img/sv76on.svg"/></span>我的客户</router-link>
                <router-link to="/toPromote/myIncome" active-class="active" class="writing_nav_list"><span><img src="@a/img/sv77.svg"/><img src="@a/img/sv77on.svg"/></span>我的收益</router-link>
                <router-link to="/toPromote/withdrawalsRecord" active-class="active" class="writing_nav_list"><span><img src="@a/img/sv78.svg"/><img src="@a/img/sv78on.svg"/></span>提现记录</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "topromoteNav",
        data() {
            return {
                
            };
        },
        computed: {
            
        },
        methods:{
           
        },
    }
</script>

<style scoped>
    @import "topromoteNav.css";
</style>